/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_WeekdayInputs */

const de__field_weekday = /** @type {(inputs: _Field_WeekdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochentag`)
};

/**

* @param {_Field_WeekdayInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_weekday = /** @type {((inputs?: _Field_WeekdayInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_WeekdayInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_weekday(inputs)
});